//login
export const ACT_LOGIN = 'LOGIN'
export const ACT_LOGOUT = 'LOGOUT'
//export const ACT_AUTHTOKEN = 'AUTHTOKEN'
//menu
export const ACT_LOGGING = 'LOGGING'
export const ACT_REPORT_HOLIDAYS = 'REPORT_HOLIDAYS'
export const ACT_REPORT_DISTANCE = 'REPORT_DISTANCE'
export const ACT_REPORT_LOGGING = 'REPORT_LOGGING'
export const ACT_REPORT_TIMESHEET = 'REPORT_TIMESHEET'
export const ACT_REPORT_SUMMARY = 'REPORT_SUMMARY'
export const ACT_REPORT_ADV = 'REPORT_ADV'
export const ACT_HELP = 'HELP'
//logging
export const ACT_GOTLOGS = 'GOT_LOGGING'
export const ACT_ADDLOG = 'ADD_LOGGING'
export const ACT_EDITLOG = 'EDIT_LOGGING'
export const ACT_COPYLOG = 'COPY_LOGGING'
export const ACT_NEWLOG = 'NEW_LOGGING'
export const ACT_CANCELADDLOGS = 'CANCEL_ADD'
//projects
export const ACT_GOTPROJECTS = 'GOT_PROJECTS'
export const ACT_GOTHOLIDAYPROJECTS = 'GOT_HOLIDAYPROJECTS'
export const ACT_GOTILLNESSPROJECTS = 'GOT_ILLNESSPROJECTS'
//app
export const ACT_FN_DISPATCH = 'SET_FN_DISPATCH'
export const ACT_FN_SETLOGTOEDIT = 'SET_FN_EDITLOG'

export const ACT_SELECTPERIOD = 'SELECT_PERIOD'

export const ACT_GOTJOBDAYINFO = 'GOT_JOBDAYINFO'

export const ACT_GOTRECENTPROJECTS = 'GOT_RECENT_PROJECTS' 